import { Create, SimpleForm, type CreateProps } from "react-admin";
import { useRouteId } from "@/utils/route-utility";
import { EventSequenceFormFields } from "./EventSequenceFormFields";

export const EventSequenceCreate = (props: CreateProps) => {
  const eventId = useRouteId();

  return (
    <Create
      {...props}
      resource="eventSequences"
      redirect={eventId ? `/events/${eventId}/#/eventSequences` : "list"}
      transform={(data: Record<string, unknown>) => ({
        eventId: eventId ?? data.eventId,
        type: data.type,
        venueCode: data.type === "NIYAAZ_FORM" ? data.venueCode : "",
        prefix: typeof data.prefix === "string" ? data.prefix.trim() : data.prefix,
        currentValue:
          data.currentValue != null && data.currentValue !== "" ? Number(data.currentValue) : 0,
      })}
    >
      <SimpleForm
        defaultValues={{ eventId, currentValue: 0 }}
        warnWhenUnsavedChanges
        sx={{ maxWidth: 700 }}
      >
        <EventSequenceFormFields showEventId={!eventId} />
      </SimpleForm>
    </Create>
  );
};
